<template>
  <div class="docs">
    <div class="docs__top">
      <div class="container">
        <div class="docs__top-wrapper">
          <el-breadcrumb separator=">">
            <el-breadcrumb-item :to="translations.i18nRoute({ name: 'home' })">{{ t('home.title') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ t('docs.terms.title') }}</el-breadcrumb-item>
          </el-breadcrumb>
          <h1 class="docs__title">{{ t('docs.terms.title') }}</h1>
        </div>
      </div>
    </div>
    <div class="docs__main">
      <div class="container">
        <div class="docs__main-wrapper" v-html="content">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import translations from "@/core/helpers/translations.js";
import {useI18n} from "vue-i18n";
import {onMounted, ref, watch} from "vue";
import {Docs} from "@/core/api/docs.js";

const {t, locale} = useI18n();

const content = ref(null)

const isLoading = ref(false)

const getDocs = async () => {
  isLoading.value = true

  const res = await Docs.getDocs("terms-of-use")

  if (res.data.posts.edges.length) {
    content.value = res.data.posts.edges[0].node.content
  }

  isLoading.value = false
}

watch(locale, async () => {
  await getDocs()
})

onMounted( async () => {
  await getDocs()
})
</script>

<style lang="scss" scoped>
.docs {
  padding-block: 80px 100px;
  color: $white;

  &__top {
    background-image: url(@images/profileTopBg.png);
    background-repeat: no-repeat;
    background-size: cover;
    padding-block: 45px 100px;
  }

  &__title {
    margin-top: 25px;
    color: #F3F3F3;
    font-size: 64px;
    font-weight: 700;
  }

  &__main {
    padding-top: 50px;
  }
}

:deep(ul) {
  padding-left: 20px;
}
:deep(p) {
  font-size: 20px;
}
:deep(li) {
  font-size: 20px;
}
:deep(a) {
  color: #ff0000;
  font-weight: 500;

  @include hover {
    color: #af0000;
  }
}

@media (max-width: 750px) {
  .docs {
    &__top {
      padding-block: 40px;
    }

    &__title {
      font-size: 42px;
    }
  }

  :deep(p) {
    font-size: 16px;
  }
  :deep(li) {
    font-size: 16px;
  }
}
</style>